import { createSlice } from "@reduxjs/toolkit";

const readWishlist = () => {
  try {
    return JSON.parse(localStorage.getItem("wishlist")) || [];
  } catch {
    return [];
  }
};

const persistWishlist = (items) => {
  localStorage.setItem("wishlist", JSON.stringify(items));
};

const initialState = {
  items: readWishlist(),
};

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    // Add item (by wishlistId + variantId)
    addWishlistItem: (state, action) => {
      const exists = state.items.find((i) => i.id === action.payload.id);
      if (!exists) {
        state.items.push(action.payload);
        persistWishlist(state.items);
      }
    },
    // Remove by variant id
    removeWishlistItem: (state, action) => {
      state.items = state.items.filter((i) => i.id !== action.payload);
      persistWishlist(state.items);
    },
    // Replace entire list (used after fetching from API)
    setWishlistItems: (state, action) => {
      state.items = action.payload;
      persistWishlist(state.items);
    },
    // Called on logout — wipes localStorage + Redux state
    clearWishlist: (state) => {
      state.items = [];
      localStorage.removeItem("wishlist");
    },
  },
});

export const {
  addWishlistItem,
  removeWishlistItem,
  setWishlistItems,
  clearWishlist,
} = wishlistSlice.actions;

export default wishlistSlice.reducer;
